module.exports = __webpack_public_path__ + "img/circle.50b915a7.png";